import { useTranslation } from 'contexts/Localization'
import React from 'react'
import { Box } from 'widgets'
import SearchInput from 'widgets/SearchInput'

function SearchBar(
  {
    isScroll,
    refContainerDropdown,
    isMobile,
  }: { isScroll?: any; refContainerDropdown?: any; isMobile?: any; isSearch?: any },
  props,
) {
  const { t } = useTranslation()

  return (
    <Box
      my="1rem"
      borderRadius="30px"
      border={`${isScroll ? '1px solid rgba(0, 0, 0, 0.5)' : 'none'}`}
      background="rgba(255, 255, 255, 0.4)"
      style={{ backdropFilter: 'blur(5px)' }}
      className="input-search-mobile"
    >
      <SearchInput
        isScroll={isScroll}
        isMobile={isMobile}
        refContainerDropdown={refContainerDropdown}
        placeholder={t('Search items, collections, account...')}
        {...props}
      />
    </Box>
  )
}

export default SearchBar
